module.exports = __webpack_public_path__ + "static/media/add-member.8e14a03f.png";